// V 2.3
class Helper {
  static timeAgo(time) {
    switch (typeof time) {
      case "number":
        break;
      case "string":
        time = +new Date(time);
        break;
      case "object":
        if (time.constructor === Date) time = time.getTime();
        break;
      default:
        time = +new Date();
    }
    let time_formats = [
      [60, "ثانیه ", 1], // 60
      [120, "1 دقیقه پیش", "یک دقیقه از الان"], // 60*2
      [3600, "دقیقه ", 60], // 60*60, 60
      [7200, "1 ساعت پیش", "1 ساعت از الان"], // 60*60*2
      [86400, "ساعت ", 3600], // 60*60*24, 60*60
      [172800, "دیروز", "فردا"], // 60*60*24*2
      [604800, "روز ", 86400], // 60*60*24*7, 60*60*24
      [1209600, "هفته پیش", "هفته بعد"], // 60*60*24*7*4*2
      [2419200, "هفته", 604800], // 60*60*24*7*4, 60*60*24*7
      [4838400, "ماه پیش", "ماه بعد"], // 60*60*24*7*4*2
      [29030400, "ماه", 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
      [58060800, "سال پیش", "سال بعد"], // 60*60*24*7*4*12*2
      [2903040000, "سال", 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
    ];
    let seconds = (+new Date() - time) / 1000,
      token = "پیش",
      list_choice = 1;

    if (seconds == 0) {
      return "همین حالا";
    }
    if (seconds < 0) {
      seconds = Math.abs(seconds);
      token = "از الان";
      list_choice = 2;
    }
    let i = 0,
      format;
    while ((format = time_formats[i++]))
      if (seconds < format[0]) {
        if (typeof format[2] == "string") return format[list_choice];
        else
          return (
            Math.floor(seconds / format[2]) + " " + format[1] + " " + token
          );
      }
    return time;
  }
  static handlePropertyCreateListError(errorArray) {
    let namesArray = [];
    if (errorArray && errorArray.length > 0) {
      errorArray.forEach((item) => {
        namesArray.push(item.courseTypeProperty.name);
      });
    }
    return namesArray;
  }
  static detailedParsedDate(date) {
    return `${Helper.timeStampToWeekDay(
      Helper.parseDate(date)
    )} ${Helper.timeStampToDay(
      Helper.parseDate(date)
    )} ${Helper.timeStampToMonth(Helper.parseDate(date))} ساعت 8 صبح`;
  }
  static parseDate(date) {
    return Date.parse(date);
  }
  static timeStampToDay(timestamp) {
    return new Date(timestamp).toLocaleDateString("fa-IR", {
      day: "numeric",
    });
  }
  static timeStampToWeekDay(timestamp) {
    return new Date(timestamp).toLocaleDateString("fa-IR", {
      weekday: "long",
    });
  }
  static timeStampToMonth(timestamp) {
    return new Date(timestamp).toLocaleDateString("fa-IR", {
      month: "long",
    });
  }
  static timeStampToHour(timestamp) {
    return new Date(timestamp).toLocaleTimeString("fa-IR", {
      hour: "2-digit",
      minute: "2-digit",
    });
  }
  static timeStampToYear(timestamp) {
    return new Date(timestamp).toLocaleDateString("fa-IR", {
      year: "numeric",
    });
  }
  static createFileAsBase64Image(fileObject, _callback) {
    const reader = new FileReader();
    reader.onload = (e) => {
      _callback(e.target.result);
    };
    reader.readAsDataURL(fileObject);
  }
  static readAsDataURL(file) {
    return new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onerror = reject;
      fr.onload = () => {
        resolve(fr.result.split(",")[1]);
      };
      fr.readAsDataURL(file);
    });
  }

  static openLoadingOverlay(context) {
    context.$store.commit("loadingOverlayStore/showLoadingOverlay");
  }

  static closeLoadingOverlay(context) {
    context.$store.commit("loadingOverlayStore/hideLoadingOverlay");
  }

  static showResponseModal(context, title, isWarning = false) {
    context.$store.commit("responseModal/toggleResponseModal");
    context.$store.commit("responseModal/setTitle", title);
    context.$store.commit("responseModal/setWarning", isWarning);
    context.$store.commit("responseModal/setCallbackUrl", callbackUrl);
  }

  static prettyPrice(price, length, decimalDelimiter, sectionDelimiter) {
    let c, d, t, s, i, j;
    c = isNaN((length = Math.abs(length))) ? 2 : length;
    d = decimalDelimiter === undefined ? "," : decimalDelimiter;
    t = sectionDelimiter === undefined ? "," : sectionDelimiter;
    s = price < 0 ? "-" : "";
    i = parseInt((price = Math.abs(+price || 0).toFixed(c))) + "";
    j = (j = i.length) > 3 ? j % 3 : 0;
    return (
      s +
      (j ? i.substr(0, j) + t : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
      (c
        ? d +
          Math.abs(price - i)
            .toFixed(c)
            .slice(2)
        : "")
    );
  }

  static showLoginModal(context, title, description) {
    context.$store.commit("LoginModal/toggleLoginModal");
    context.$store.commit("LoginModal/setTitle", title);
    if (title !== "") {
      context.$toastMessage(context, description, "error");
    }
  }

  static showRefreshSearchModal(context, title, description) {
    context.$store.commit("RefreshSearchModal/toggleRefreshSearchModal");
    context.$store.commit("RefreshSearchModal/setTitle", title);
    if (title !== "") {
      context.$toastMessage(context, description, "error");
    }
  }

  static arrayRemove(arr, value) {
    return arr.filter(function (ele) {
      return ele !== value;
    });
  }

  static isAdded(array) {
    return array === param;
  }

  static myJoin(arr, sep = ",") {
    arr = arr.map((e) => ([undefined, null].includes(e) ? "" : e));
    let result = "";
    arr.forEach((e, i) => (result += `${i ? sep : ""}${e}`));
    return result;
  }

  static generateExcel(response) {
    const file = new Blob([response.data], {
      type: "application/vnd.ms-excel",
    });
    return { file };
  }
  static generateFormData(data) {
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
      if (data && data[key]) {
        if (!Array.isArray(data[key])) {
          if (typeof data[key] === "object" && !(data[key] instanceof File)) {
            Object.keys(data[key]).forEach((objKey) => {
              if (data[key][objKey] != null) {
                formData.append(`${key}.${objKey}`, data[key][objKey]);
              }
            });
          } else {
            if (data[key] != null) {
              formData.append(key, data[key]);
            }
          }
        } else if (Array.isArray(data[key])) {
          data[key].forEach((arrayItem, index) => {
            if (typeof arrayItem == "object" && !(arrayItem instanceof File)) {
              Object.keys(arrayItem).forEach((innerKey) => {
                if (arrayItem[innerKey] != null) {
                  formData.append(
                    `${key}[${index}].${innerKey}`,
                    arrayItem[innerKey]
                  );
                }
              });
            } else {
              if (arrayItem != null) {
                formData.append(`${key}[${index}]`, arrayItem);
              }
            }
          });
        }
      }
    });
    return formData;
  }
}

export default Helper;
